

// SELECT LABEL UP

document.addEventListener('DOMContentLoaded', function() {
    // Función para actualizar la etiqueta del select
    function updateSelectLabel(select) {
        const label = document.querySelector(`label[for="${select.id}"]`);
        if (select.value) {
            label.style.top = '0px';
            label.style.left = '0';
            label.style.fontSize = '12px';
            label.style.color = 'black';
        } else {
            label.style.top = '50%';
            label.style.transform = 'translateY(-50%)';
            label.style.fontSize = '16px';
            label.style.color = 'gray';
        }
    }

    // Obtener todos los selects
    const selects = document.querySelectorAll('.form__select-up select');

    // Añadir eventos de cambio a cada select
    selects.forEach(select => {
        select.addEventListener('change', function() {
            updateSelectLabel(this);
        });

        // Inicializa la etiqueta en función del valor del select
        updateSelectLabel(select);
    });
});


// BTN SUBIR ARCHIVO

$(document).ready(function() {
    $('#fileUpload').on('change', function() {
        var fileName = $(this).val().split('\\').pop();
        $('#file-upload-filename').text(fileName ? fileName : 'Ningún archivo seleccionado');
    });
});


// CALENDAR (LABEL UP)

$(document).ready(function() {
    $.datepicker.setDefaults($.datepicker.regional["es"]);
    
    $('.form__calendar input').each(function() {
        $(this).datepicker({
            dateFormat: "dd-mm-yy",
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:2024",
            showButtonPanel: true,
            closeText: 'Cerrar',
            currentText: 'Hoy',
            monthNames: ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
                'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
            monthNamesShort: ['Ene','Feb','Mar','Abr','May','Jun',
                'Jul','Ago','Sep','Oct','Nov','Dic'],
            dayNames: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
            dayNamesShort: ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
            dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sá'],
            firstDay: 1, // Inicia el calendario desde el lunes
            beforeShow: function(input, inst) {
                $(inst.dpDiv).addClass('custom-datepicker');
                $(input).prev('.form__calendar label').addClass('active');
            },
            onClose: function(dateText, inst) {
                var input = $(this);
                if (dateText) {
                    input.prev('.form__calendar label').addClass('active');
                } else {
                    input.prev('.form__calendar label').removeClass('active');
                }
            }
        });

        $(this).focus(function() {
            $(this).prev('.form__calendar label').addClass('active');
        });

        $(this).blur(function() {
            if (!$(this).val()) {
                $(this).prev('.form__calendar label').removeClass('active');
            }
        });
    });
});


// CONTACTAR POR WHATSAPP

document.addEventListener("DOMContentLoaded", function() {
    var whatsappLink = document.getElementById("whatsappLink");
    
    if (whatsappLink) {
        var countryPrefix = "34"; // Reemplaza con el prefijo de tu país
        var phoneNumber = "623100086"; // Reemplaza con el número de teléfono
        var message = "Hola, tengo una consulta"; // Reemplaza con el mensaje predefinido
        var encodedMessage = encodeURIComponent(message);
        var fullWhatsappLink = "https://wa.me/" + countryPrefix + phoneNumber + "?text=" + encodedMessage;

        whatsappLink.setAttribute("href", fullWhatsappLink);
    }
});


// ERRORES

(function () {
  function isEmpty(field) {
    if (field.disabled) return false;
    const tag  = field.tagName.toLowerCase();
    const type = (field.type || '').toLowerCase();

    if (type === 'checkbox' || type === 'radio') {
      const form  = field.form || document;
      const group = form.querySelectorAll(`input[name="${field.name}"][type="${type}"]`);
      return !Array.from(group).some(i => i.checked);
    }
    if (tag === 'select') return !field.value || field.value === '';
    return !String(field.value).trim();
  }

  function markError(field) {
    const gridCol = field.closest('.grid-col');
    if (gridCol) gridCol.classList.add('error');
  }

  function clearError(field) {
    const gridCol = field.closest('.grid-col');
    if (gridCol) gridCol.classList.remove('error');
  }

  function ensureGlobalMsg(form, msg) {
    const sendGrid = form.querySelector('.grid.send');
    if (!sendGrid) return;

    let box = form.querySelector('.form-error-global');
    if (!box) {
      box = document.createElement('div');
      box.className = 'form-error-global';
      box.textContent = msg || 'Revisa los campos marcados';
      sendGrid.parentNode.insertBefore(box, sendGrid);
    } else {
      box.textContent = msg || 'Revisa los campos marcados';
    }
  }

  function removeGlobalMsg(form) {
    const box = form.querySelector('.form-error-global');
    if (box) box.remove();
  }

  function validate(form) {
    // limpiar estado previo
    form.querySelectorAll('.grid-col.error').forEach(el => el.classList.remove('error'));

    let firstInvalid = null;

    const fields = form.querySelectorAll('[required]:not([type="hidden"])');
    fields.forEach(field => {
      if (isEmpty(field)) {
        if (!firstInvalid) firstInvalid = field;
        if (field.type === 'radio' || field.type === 'checkbox') {
          // marca todos los del grupo
          const group = form.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
          group.forEach(markError);
        } else {
          markError(field);
        }
      }
    });

    if (firstInvalid) {
      ensureGlobalMsg(form, 'Completa los campos marcados en rojo.');
    } else {
      removeGlobalMsg(form);
    }

    return firstInvalid;
  }

  document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll('form');
    if (!forms.length) return;

    forms.forEach(form => {
      form.setAttribute('novalidate', '');

      form.addEventListener('submit', function (e) {
        const firstInvalid = validate(form);
        if (firstInvalid) {
          e.preventDefault();
          firstInvalid.focus({ preventScroll: false });
        }
      });

      // limpiar error al corregir (inputs/selects)
      form.addEventListener('input', function (e) {
        const el = e.target;
        if (!el.matches('[required]')) return;

        const type = (el.type || '').toLowerCase();
        if (type !== 'radio' && type !== 'checkbox') {
          if (!isEmpty(el)) {
            clearError(el);
            // si ya no quedan errores, quita el global
            if (!form.querySelector('.grid-col.error')) removeGlobalMsg(form);
          }
        }
      });

      // radios/checkbox y selects
      form.addEventListener('change', function (e) {
        const el = e.target;
        if (!el.matches('[required]')) return;

        const type = (el.type || '').toLowerCase();
        if (type === 'radio' || type === 'checkbox') {
          const group = form.querySelectorAll(`input[name="${el.name}"][type="${type}"]`);
          const anyChecked = Array.from(group).some(i => i.checked);
          group.forEach(input => (anyChecked ? clearError(input) : markError(input)));
        } else if (el.tagName.toLowerCase() === 'select') {
          if (!isEmpty(el)) clearError(el);
        }

        if (!form.querySelector('.grid-col.error')) removeGlobalMsg(form);
      });
    });
  });
})();




